import React from 'react';
import { Box } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { setImagePreviewModal } from '@/shared/ui';
import { useAppDispatch } from '@/app/store';

interface ImageWithPreviewProps {
  src: string;
  alt: string;
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  iconSize?: number;
}

const ImageWithPreview: React.FC<ImageWithPreviewProps> = ({
  src,
  alt,
  width = '100%',
  height = '150px',
  borderRadius = '8px',
  iconSize = 28,
}) => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(setImagePreviewModal(src));
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width,
        height,
        borderRadius,
        overflow: 'hidden',
        cursor: 'pointer',
        '&:hover .preview-icon': {
          opacity: 1,
        },
      }}
      onClick={handleClick}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
      <Box
        className="preview-icon"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          borderRadius: '50%',
          width: iconSize + 20,
          height: iconSize + 20,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0,
          transition: 'opacity 0.2s',
        }}
      >
        <VisibilityIcon sx={{ color: 'white', fontSize: iconSize }} />
      </Box>
    </Box>
  );
};

export default ImageWithPreview;
